import React from 'react';
import { createSvgIcon } from './createSvgIcon';
export const ChevronLeftIcon = createSvgIcon({
    displayName: 'ChevronLeft',
    path: React.createElement("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }),
});
